
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1Q21q", function(module, exports) {

$parcel$export(module.exports, "EngagementInlineDialogWrapper", () => $4ead1b0c84785c64$export$81ac9ce93f56b5bb);

var $gwFzn = parcelRequire("gwFzn");

var $kkQZq = parcelRequire("kkQZq");

var $luv00 = parcelRequire("luv00");
const $4ead1b0c84785c64$export$81ac9ce93f56b5bb = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    // there are multiple engagement inline dialog loaders used for navigation, so we're using
    // dataVC to distinguish for reporting
    const { children: children, dataVC: dataVC, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kkQZq.default), restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": dataVC,
        ...ssrPlaceholderIdProp
    }, children));
};

});


//# sourceMappingURL=EngagementInlineDialogWrapper.71fdcf39.js.map
